__turbopack_context__.v({
  "className": "poppins_16a2733c-module__NjV6Oa__className",
});
